/** @file Creates an empty animation (`walk` or `walk@SE`), optionally with a length in frames. */
import { z } from 'zod';
import { defineCreate } from '../_shared/defineCreate';

/** animation.create: empty timelines; the name may carry one @DIR suffix. */
export const command = defineCreate({
  domain: 'animation',
  kind: 'animation',
  description: 'Create an empty animation `name` (`<base>` or `<base>@<DIR>`, DIR one of N NE E SE S SW W NW) with an optional durationFrames.',
  schema: z
    .object({
      id: z.string().exactOptional(),
      name: z.string().min(1),
      durationFrames: z.number().int().positive().exactOptional(),
    })
    .strict(),
  build(input) {
    return {
      name: input.name,
      ...(input.durationFrames === undefined ? {} : { durationFrames: input.durationFrames }),
      bones: {}, slots: {}, ik: {}, deform: {}, drawOrder: [], events: [],
    };
  },
});
